import React from "react";
import { AnimatePresence, motion } from "motion/react";
import { X, LogOut, ArrowDownRight, Coffee } from "lucide-react";

const formatTime = (ts) => {
  if (!ts) return "--:--";
  return new Date(ts).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

const fmt = (s) => {
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}m ${r}s`;
};

export default function OnBreakModal({
  open,
  onClose,
  breakAt,
  breakSec,
  workSec,
  onResume,
  onCheckOut,
}) {
  return (
    <AnimatePresence>
      {open ? (
        <>
          <motion.div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[70]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />

          <motion.div
            className="fixed inset-0 z-[80] flex items-center justify-center px-4"
            initial={{ opacity: 0, scale: 0.96, y: 12 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96, y: 12 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
          >
            <div
              className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl border border-orange-200 overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={onClose}
                className="absolute top-4 right-4 w-9 h-9 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition"
              >
                <X className="w-5 h-5 text-slate-500" />
              </button>

              <div className="p-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center">
                    <Coffee className="w-5 h-5 text-white" />
                  </div>
                  <h2 className="text-2xl font-bold text-orange-600">On Break</h2>
                </div>

                <div className="mt-5 bg-orange-50 rounded-xl p-4 border border-orange-200">
                  <div className="flex justify-between text-sm text-slate-600">
                    <span>Break started:</span>
                    <span className="font-semibold text-orange-700">
                      {formatTime(breakAt)}
                    </span>
                  </div>

                  <div className="flex justify-between text-sm text-slate-600 mt-3">
                    <span>Current break:</span>
                    <span className="font-semibold text-orange-700">{fmt(breakSec)}</span>
                  </div>

                  <div className="flex justify-between text-sm text-slate-600 mt-3">
                    <span>Total work time:</span>
                    <span className="font-semibold text-orange-700">{fmt(workSec)}</span>
                  </div>
                </div>

                <div className="mt-6 grid grid-cols-2 gap-3">
                  <button
                    onClick={onResume}
                    className="h-12 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold flex items-center justify-center gap-2 shadow-lg shadow-blue-600/20 transition"
                  >
                    <ArrowDownRight className="w-5 h-5" />
                    Resume Work
                  </button>

                  <button
                    onClick={onCheckOut}
                    className="h-12 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-semibold flex items-center justify-center gap-2 shadow-lg shadow-slate-900/20 transition"
                  >
                    <LogOut className="w-5 h-5" />
                    Check Out
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </>
      ) : null}
    </AnimatePresence>
  );
}